module.exports = __webpack_public_path__ + "static/media/iphones.3636e97f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/instagram-promo/iphones.png
// module id = 2462
// module chunks = 7